import createIcon from '../../createIcon';

/**
 * @component @name HomeMini
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNUM0LjE5IDUgMiA5LjQ4IDIgMTJDMiAxNS44NiA1LjEzIDE5IDguOTkgMTlIMTUuMDFDMTcuNyAxOSAyMiAxNi45MiAyMiAxMkMyMiAxMiAyMiA1IDEyIDVaTTEyIDdDMTkuNjQgNyAxOS45OSAxMS41MSAyMCAxMkg0QzQgMTEuOCA0LjA5IDcgMTIgN1pNMTQuODYgMTdIOS4xNEM3LjA0IDE3IDUuMjIgMTUuNzYgNC40MyAxNEgxOS41OEMxOC43OCAxNS43NiAxNi45NiAxNyAxNC44NiAxN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HomeMini = createIcon('HomeMini', [
  [
    'path',
    {
      d: 'M12 5C4.19 5 2 9.48 2 12C2 15.86 5.13 19 8.99 19H15.01C17.7 19 22 16.92 22 12C22 12 22 5 12 5ZM12 7C19.64 7 19.99 11.51 20 12H4C4 11.8 4.09 7 12 7ZM14.86 17H9.14C7.04 17 5.22 15.76 4.43 14H19.58C18.78 15.76 16.96 17 14.86 17Z',
      key: 'gwaml7',
    },
  ],
]);

export default HomeMini;
